var spoiler_default = {
  "fontElementMap": "vHc1u",
  "hideText": "DaFYe",
  "onHoverText": "OENh-",
  "hideBlock": "iEgHY",
  "smallBlur": "E-g8S",
  "mediumBlur": "_1Z9VK",
  "largeBlur": "OmehM",
  "hideBlock_gallery": "aT-Rd",
  "overlay": "lZ--v",
  "overlay_gallery": "ekVMP",
  "revealSpoilerBtn": "_3Ezae",
  "isMobile": "thC2Y",
  "onHoverBtn": "vx9Kd",
  "spoilerWrapper": "BquSY",
  "spoilerDescription": "_3cV3D",
  "spoilerContainer": "_919QM",
  "spoilerContainer_Gallery": "p1GoP",
  "spoiler-text-blur": "wUQFW"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
